import { customAxios, customFileAxios } from "./customAxios";


/**
 * 업체 구분별 건수
 * @param {*} query 
 * @returns 
 */
export const getCompaniesGroupCountByType = async(query)=>{
  const res = await customAxios.get('/api/company/countByType', {params : query});
  //console.log(res);
  if (res && res.data) {
      //return Object.values(res.data);
      return res.data;
  }
  return null;
}

/**
 * 업체 전체 목록
 * @returns 
 */
export const getCompanyAll = async()=>{
  const res = await customAxios.get('/api/company');
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getCompaniesByQuery = async(query)=>{
  const res = await customAxios.get('/api/company', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 상세
 * @param {*} id 
 * @returns 
 */
export const getCompanyById = async(id)=>{
  const res = await customAxios.get('/api/company/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 등록
 * @param {*} body 
 */
export const postCompany = async(body)=>{
  //console.log(body);
  await customFileAxios.post('/api/company',body);
}

/**
 * 업체 수정
 * @param {*} body 
 */
export const patchCompany = async(id, body)=>{
  //console.log(body);
  await customFileAxios.patch('/api/company/'+id, body);
}

// ===========================================================

/**
 * 업체 기본정보 전체 목록
 * @returns 
 */
export const getCompanyInfoAll = async()=>{
  const res = await customAxios.get('/api/company/info');
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 기본정보 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getCompanyInfosByQuery = async(query)=>{
  const res = await customAxios.get('/api/company/info', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 기본정보 목록(파라미터)
 * @param {*} query(*domain, excludeId )
 * @returns 
 */
export const getCompanyInfoExistsByQuery = async(query)=>{
  const res = await customAxios.get('/api/company/info/exists', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 기본정보 상세
 * @param {*} id 
 * @returns 
 */
export const getCompanyInfoById = async(id)=>{
  const res = await customAxios.get('/api/company/info/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 업체 기본정보 등록
 * @param {*} body 
 */
export const postCompanyInfo = async(body)=>{
  //console.log(body);
  await customFileAxios.post('/api/company/info',body);
}

/**
 * 업체 기본정보 수정
 * @param {*} body 
 */
export const patchCompanyInfo = async(id, body)=>{
  //console.log(body);
  await customFileAxios.patch('/api/company/info/'+id, body);
}
